import React from 'react'
import '../App.css'
import {Bodywaitbuy} from './bodywaitbuy'
export class Bodyappwaitbuybody extends React.Component {
    state = {
    }
    render() {       
        return (
            <div className='sshbodyapp'>
                <div className='sshbodyappContainer'>
                    <Bodywaitbuy/>
                </div>
            </div>
        );
    }
}